import { FC } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * @description Props for the UnitsHeader component
 * @interface UnitsHeaderProps
 */
type UnitsHeaderProps = {
  /** Flag indicating whether the user has permission to manage concentration units */
  canManage: boolean;
};

/**
 * @description Header component displaying column labels for concentration limits.
 * Shows lower/upper hard/soft limit columns and units column.
 *
 * @SADtrace SAD-003-4.1, SAD-003-4.2, SAD-003-4.3
 *
 * @History
 * 04-18-2025 aleksandar dukleski: DLA-1364 added function headers
 * 11-05-2025 aleksandar dukleski: DLA-1428 added history tag to function headers
 *
 * @param {UnitsHeaderProps} props - Component props
 *
 * @returns {JSX.Element} Rendered component
 */
const UnitsHeader: FC<UnitsHeaderProps> = ({ canManage }) => {
  const { t } = useTranslation();

  return (
    <div className="row pb-3 pt-5 position-relative" data-testid="units-header">
      {!canManage && (
        <div className="device-concentration--disabled-item"></div>
      )}
      <div className="device-concentration-form__label"></div>
      <div className="device-concentration__box-input justify-content-center text-center">
        {t('device.lower_hard_limit')}
      </div>
      <div className="device-concentration__box-input justify-content-center text-center">
        {t('device.lower_soft_limit')}
      </div>
      <div className="device-concentration__box-input justify-content-center text-center">
        {t('device.upper_soft_limit')}
      </div>
      <div className="device-concentration__box-input justify-content-center text-center">
        {t('device.upper_hard_limit')}
      </div>
      <div className="col-care-area-units">{t('device.units')}</div>
    </div>
  );
};

export default UnitsHeader;
